import { atom } from 'jotai';

export const JDE_ENV_PROD = 'prod';
export const JDE_ENV_TEST = 'test';
export const JDE_ENV_DEV = 'dev';

export const jdeEnvAtom = atom(JDE_ENV_PROD);

const ORCH_BASES = {
    [JDE_ENV_PROD]: 'https://jdeorch.strikeusa.com:443/jderest/orchestrator',
    [JDE_ENV_TEST]: 'https://jdeorchtest.strikeusa.com:443/jderest/orchestrator',
    [JDE_ENV_DEV]: 'https://jdeorchdev.strikeusa.com:443/jderest/orchestrator',
};

// TODO: confirm HA/Mule base URLs — muleprod DSN and muletest DSN both currently
// resolve to the PCForecasting prod DB, so "test" here may not be a true test source.
const HA_BASES = {
    [JDE_ENV_PROD]: null,
    [JDE_ENV_TEST]: null,
};

const normalize = (env) => {
    if (env === JDE_ENV_TEST) return JDE_ENV_TEST;
    if (env === JDE_ENV_DEV) return JDE_ENV_DEV;
    return JDE_ENV_PROD;
};

export const getOrchBase = (env) => ORCH_BASES[normalize(env)];

export const getHaBase = (env) => HA_BASES[normalize(env)];

export const buildOrchUrl = (env, orchName) => `${getOrchBase(env)}/${orchName}`;

// JDE service-account credentials. Prod and non-prod use different users —
// hitting the dev/test orchestrator URL with the prod credential auth-fails
// (often surfaced as a 500). Pair the credential with the URL.
const ORCH_AUTH = {
    [JDE_ENV_PROD]: 'Basic MTQ4Njk1Oks2b1chKmVJZ216dDZWd2Y=',  // 148695
    [JDE_ENV_TEST]: 'Basic MTQ4Njk0OlV4ZTBUbWotV1Q5OGJGQXE=',  // 148694
    [JDE_ENV_DEV]:  'Basic MTQ4Njk0OlV4ZTBUbWotV1Q5OGJGQXE=',  // 148694
};

export const getOrchAuth = (env) => ORCH_AUTH[normalize(env)];

// Reads (loadJDEValues, loadHAExistsArray, loadBudgetExistsArray, etc.) only have
// prod/test backing DSNs configured. Dev shares the prod source — so callers
// should resolve their env through this helper before passing to a read API.
export const getReadEnv = (env) => (env === JDE_ENV_DEV ? JDE_ENV_PROD : normalize(env));

// Badge color mapping — keep prod/test/dev visually distinct everywhere.
export const envColor = (env) => {
    if (env === JDE_ENV_PROD) return '#dc2626';
    if (env === JDE_ENV_TEST) return '#059669';
    if (env === JDE_ENV_DEV) return '#2563eb';
    return '#6b7280';
};
